import { Section } from "../components/Section";
import { TestSpecDetailForm } from "../components/tests/TestSpecDetailForm";

export function NewTestSpecPage() {
  return (
    <div className="flex flex-col flex-1 max-w-3xl">
      <Section.Title>New test spec</Section.Title>
      <TestSpecDetailForm />
    </div>
  );
}
